import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import {Link, useLocation} from 'react-router-dom';

function Header() {
    const location = useLocation();
    const navItems = [
        {label: "RIMap-RISC", to: "/"},
        {label: "How to use RIMap-RISC", to: "/about"},
        {label: "To cite RIMap-RISC", to: "/paper"}
    ];

    return (
        <Paper
            elevation={3}
            square={false}
            sx={{
                width: '100%',
                bgcolor: 'white',
                pb: 2,
                borderBottom: 1,
                borderColor: 'grey.200',
                borderBottomLeftRadius: 16,
                borderBottomRightRadius: 16
            }}
        >
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <img
                    src="/images/RIMapRISCLogo.png"
                    alt="RIMap-RISC Logo"
                    style={{height: 64, objectFit: 'contain', maxWidth: '100%', marginTop: 48}}
                />
                <Box sx={{display: 'flex', gap: 2, mt: 2}}>
                    {navItems.map(item => (
                        <Button
                            key={item.to}
                            component={Link}
                            to={item.to}
                            variant={location.pathname === item.to ? "contained" : "outlined"}
                            color="primary"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 3,
                                boxShadow: location.pathname === item.to ? 2 : 0,
                                bgcolor: location.pathname === item.to ? 'primary.main' : 'white',
                                color: location.pathname === item.to ? 'white' : 'primary.main',
                                '&:hover': {
                                    bgcolor: location.pathname === item.to ? 'primary.dark' : 'grey.100'
                                }
                            }}
                        >
                            {item.label}
                        </Button>
                    ))}
                </Box>
            </Box>
        </Paper>
    );
}

export default Header;
